import { render } from "./IconItemCategory.vue?vue&type=template&id=b92b7022&ts=true"
import script from "./IconItemCategory.vue?vue&type=script&lang=ts"
export * from "./IconItemCategory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__